/* @jsxImportSource @emotion/react */

import React from 'react'
import { FormattedMessage } from 'react-intl'
import { usePageContext } from 'vike-react/usePageContext'

const barCss = {
  position: 'fixed',
  bottom: 16,
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: 1002,
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  padding: '10px 10px 10px 20px',
  borderRadius: 999,
  background: 'var(--shade-00)',
  color: 'var(--shade-100)',
  fontSize: 'var(--font-size-7)',
  whiteSpace: 'nowrap',
  boxShadow: '0 8px 24px -8px rgba(0, 0, 0, 0.35)',
} as const

const exitLinkCss = {
  padding: '6px 14px',
  borderRadius: 999,
  background: 'var(--shade-100)',
  color: 'var(--shade-00)',
  fontWeight: 600,
  textDecoration: 'none',
  '&:hover': { opacity: 0.85, color: 'var(--shade-00)' },
} as const

/** Shown while Sanity draft preview is on, so drafts are never mistaken for live content. */
export function DraftPreviewBar() {
  // A bare "?preview=off" href makes Vike's client router load the home
  // page's data under the current URL, so the path has to be spelled out.
  const { pathname } = usePageContext().urlParsed

  return (
    <div role="status" css={barCss}>
      <FormattedMessage
        id="website.draftPreview.notice"
        defaultMessage="Previewing unpublished Sanity drafts"
      />
      <a href={`${pathname}?preview=off`} css={exitLinkCss}>
        <FormattedMessage
          id="website.draftPreview.exit"
          defaultMessage="Exit preview"
        />
      </a>
    </div>
  )
}
